import React from "react";
import { motion } from "framer-motion";
import { useSigninModal } from "../../context/SigninModalContext";
import HeroShopScene from "./HeroShopScene";
import "./Herosection.scss";
import "./HeroShopScene.scss";

const EXT_URL =
  "https://chromewebstore.google.com/detail/ollacart-extension/hpbmlmabfkbhmhjhocddfckebbnbkcbm";
const IOS_URL = "https://apps.apple.com/us/app/ollacart/id6476688090";

const Herosection = () => {
  const { openSignin } = useSigninModal();

  return (
    <section className="lp-hero" id="hero" aria-label="OllaCart">
      <div className="lp-hero__atmosphere" aria-hidden="true">
        <HeroShopScene />
        <div className="lp-hero__veil" />
      </div>

      <motion.div
        className="lp-hero__content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65, ease: "easeOut" }}
      >
        <div className="lp-hero__brand" aria-label="OllaCart">
          <svg
            className="lp-hero__logo"
            width="220"
            height="99"
            viewBox="0 0 140 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-hidden="true"
          >
            <path d="M60.9211 39.3033C60.9211 42.5692 58.4372 44.9608 55.1025 44.9608C51.7687 44.9608 49.2852 42.5688 49.2852 39.3033C49.2852 36.0381 51.7687 33.6465 55.1025 33.6465C58.4375 33.6465 60.9211 36.0384 60.9211 39.3033ZM51.676 39.3033C51.676 41.3961 53.0791 42.7531 55.1022 42.7531C57.1264 42.7531 58.5287 41.3961 58.5287 39.3033C58.5287 37.2111 57.1264 35.8542 55.1022 35.8542C53.0791 35.8542 51.676 37.2111 51.676 39.3033Z" fill="white" />
            <path d="M65.3593 44.616H63.1055V28.5186H65.3593V44.616Z" fill="white" />
            <path d="M70.6011 44.616H68.3477V28.5186H70.6011V44.616Z" fill="white" />
            <path d="M72.7852 39.3033C72.7852 35.7626 75.1538 33.6465 77.9593 33.6465C79.707 33.6465 80.8797 34.4057 81.5465 35.5555H81.5923V33.9914H83.8458V44.6159H81.5923V43.0518H81.5465C80.8797 44.2016 79.707 44.9608 77.9593 44.9608C75.1538 44.9612 72.7852 42.8458 72.7852 39.3033ZM81.7079 39.3033C81.7079 37.2802 80.4204 35.8542 78.4419 35.8542C76.4643 35.8542 75.1767 37.2802 75.1767 39.3033C75.1767 41.3271 76.4643 42.7531 78.4419 42.7531C80.4204 42.7531 81.7079 41.3271 81.7079 39.3033Z" fill="white" />
            <path d="M86.4922 39.3033C86.4922 35.9236 88.9067 33.6465 92.3336 33.6465C93.7127 33.6465 94.8854 34.0146 95.9666 34.7276L94.9087 36.6359C94.1732 36.1762 93.253 35.8313 92.2642 35.8313C90.2171 35.8313 88.8838 37.3027 88.8838 39.3036C88.8838 41.3046 90.2171 42.7767 92.2642 42.7767C93.253 42.7767 94.1732 42.4319 94.9087 41.9714L95.9666 43.8804C94.8854 44.5934 93.7127 44.9616 92.3336 44.9616C88.9067 44.9612 86.4922 42.684 86.4922 39.3033Z" fill="white" />
            <path d="M97.1172 39.3033C97.1172 35.7626 99.4863 33.6465 102.291 33.6465C104.039 33.6465 105.211 34.4057 105.879 35.5555H105.924V33.9914H108.177V44.6159H105.924V43.0518H105.879C105.211 44.2016 104.039 44.9608 102.291 44.9608C99.4863 44.9612 97.1172 42.8458 97.1172 39.3033ZM106.04 39.3033C106.04 37.2802 104.752 35.8542 102.774 35.8542C100.797 35.8542 99.5084 37.2802 99.5084 39.3033C99.5084 41.3271 100.797 42.7531 102.774 42.7531C104.752 42.7531 106.04 41.3271 106.04 39.3033Z" fill="white" />
            <path d="M116.916 36.315H116.571C114.364 36.315 113.19 37.3729 113.19 39.9026V44.6167H110.938V33.9921H113.19V36.3146H113.237C113.743 34.7284 114.961 33.6709 116.755 33.6709H116.916V36.315H116.916Z" fill="white" />
            <path d="M121.628 35.9007V41.4659C121.628 42.2243 121.95 42.5696 122.732 42.5696H123.284V44.6395H122.249C120.386 44.6395 119.374 43.6507 119.374 41.9027V35.9007H117.488V33.9917H119.374V29.7373H121.628V33.9917H123.789V35.9007H121.628Z" fill="white" />
            <path d="M33.9183 40.2165C33.5643 41.7761 32.3027 42.7447 30.5955 42.7447C28.5717 42.7447 27.1689 41.3877 27.1689 39.2948C27.1689 38.0947 27.6324 37.1386 28.408 36.5393L27.6053 34.6021L27.888 35.2831L27.5306 34.4209C25.8493 35.3815 24.7773 37.1493 24.7773 39.2945C24.7773 42.5604 27.2609 44.952 30.5955 44.952C33.6074 44.952 35.9242 43.0007 36.3442 40.2162H36.0394L33.9183 40.2165Z" fill="#009FB7" />
            <path d="M57.0194 31.8649C56.8576 31.8649 56.6928 31.8298 56.5376 31.7554C55.9779 31.4891 55.7402 30.8192 56.0065 30.2592C56.8233 28.5447 57.5107 26.6704 57.6683 25.7873C55.8505 25.5714 50.0259 25.7057 44.8246 25.9906C44.2077 26.0242 43.6763 25.5504 43.6423 24.9312C43.6084 24.3121 44.083 23.7829 44.7017 23.749C44.7334 23.7471 47.9341 23.5723 51.2333 23.4861C58.207 23.3026 58.8063 23.6696 59.2027 23.9123C60.3376 24.6077 60.0305 26.2127 59.2206 28.4081C58.6934 29.8365 58.0601 31.169 58.033 31.2251C57.8411 31.6291 57.439 31.8649 57.0194 31.8649Z" fill="#FFC827" />
            <path d="M46.0099 37.9692H31.9573C31.665 37.9692 31.361 37.812 31.2812 37.6197C31.2809 37.6182 31.2801 37.6175 31.2797 37.6159L24.826 22.0739L24.8256 22.0743L24.3347 20.8917C24.1714 20.4984 23.6895 20.1768 23.2634 20.1768H22.6526H21.6989H15.3841C14.7641 20.1768 14.2617 20.6792 14.2617 21.2991C14.2617 21.919 14.7641 22.4215 15.3841 22.4215H21.6989H21.7649C22.1888 22.4215 22.6679 22.7404 22.8335 23.1314L29.0556 38.1115C29.0579 38.1168 29.0591 38.121 29.061 38.1271L29.5714 39.3559C29.7671 39.8274 30.3454 40.2135 30.8566 40.2135H31.559C31.5613 40.2135 31.5632 40.2135 31.5651 40.2135H46.0099C46.6302 40.2135 47.1327 39.7107 47.1327 39.0908C47.1327 38.4724 46.6302 37.9692 46.0099 37.9692Z" fill="#FE4A49" />
          </svg>
        </div>
        <h1 className="lp-hero__title">
          Don’t be afraid to{" "}
          <span className="lp-hero__highlight">close all your shopping tabs.</span>
        </h1>
        <p className="lp-hero__lead">
          One cart across stores. Save what you like, share when you want
          feedback, and check out without starting over.
        </p>

        <div className="lp-hero__actions">
          <button
            type="button"
            className="lp-hero__btn lp-hero__btn--primary"
            onClick={openSignin}
          >
            Start free
          </button>
          <a
            className="lp-hero__btn lp-hero__btn--ghost"
            href={IOS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get the iOS app
          </a>
          <a
            className="lp-hero__btn lp-hero__btn--ghost"
            href={EXT_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get the extension
          </a>
        </div>

      </motion.div>
    </section>
  );
};

/** Right below the hero: the brand line, as its own band. */
export const SocialBanner = () => (
  <section className="lp-social-banner" aria-label="Built to be social">
    <motion.p
      className="lp-social-banner__title"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.6 }}
      transition={{ duration: 0.55, ease: "easeOut" }}
    >
      Better shopping. <span className="lp-social-banner__accent">Built to be social.</span>
    </motion.p>
  </section>
);

export default Herosection;
